// import i18n from '@/i18n'
import {createLogger} from './log'

import {
  StoreEvents,
  storeEventLister,
  manualEventListener,
} from './event-dispatcher'

const logger = createLogger('GA-Subscriber', '📊', false)

export const createGAListeners = (analyticstype, ga) => {
  console.log(analyticstype, ga)

  let subscribers = []
  if (analyticstype == 'ua' || analyticstype == 'both') {
    //track product impression
    subscribers.push(
      storeEventLister(StoreEvents.SEARCH_PRODUCTS_UPDATED, m => {
        const products = m.payload.results

        logger.print('SEARCH_PRODUCTS_UPDATED', products)

        console.log(ga.ecommerce)

        try {
          products.forEach((element, index) => {
            ga.ecommerce.addImpression({
              id: element.id,
              name: `${element.contact.name} - ${element.display}`,
              category: 'Urlaubsgutschein',
              brand: element.vendor.name,
              list: 'Suche',
              position: index + 1,
            })
          })
        } catch (err) {
          logger.error('Failed SEARCH_PRODUCTS_UPDATED', err)
        }
      }),
    )

    //track offerclick
    subscribers.push(
      manualEventListener('offer_clicked', payload => {
        const product = payload.product
        logger.print('clicked offerelement', payload, product)

        try {
          ga.ecommerce.addProduct({
            id: product.id,
            name: product.display,
            price: product.price,
            quantity: 1,
            // variant: cartItem.variantId,
          })
          ga.ecommerce.setAction('click', {list: 'Search Results'})
          ga.ecommerce.send('event', 'UX', 'click', 'Results')
        } catch (err) {
          logger.error('Failed HOTEL_OFFER_LOADED', err)
        }
      }),
    )

    //track item view
    subscribers.push(
      storeEventLister(StoreEvents.HOTEL_OFFER_LOADED, m => {
        const offer = m.payload
        logger.print('HOTEL_OFFER_LOADED', offer, offer.variants)

        try {
          // ga.event('view_item', {
          //   items: [
          //     {
          //       id: offer.id,
          //       name: offer.title,
          //       category: 'Urlaubsgutschein',
          //     },
          //   ],
          // })

          ga.ecommerce.addProduct({
            id: offer.id,
            name: `${offer.subtitle} - ${offer.title}`,
            price: offer.unitPrice,
            quantity: offer.quantity,
            variant: offer.variantId,
          })
          ga.ecommerce.setAction('detail')
        } catch (err) {
          logger.error('Failed HOTEL_OFFER_LOADED', err)
        }
      }),
    )

    //track add to cart
    subscribers.push(
      storeEventLister(StoreEvents.PRODUCT_ADDED, m => {
        const cartItem = m.payload

        logger.print('PRODUCT_ADDED', cartItem)

        try {
          ga.ecommerce.addProduct({
            id: cartItem.id,
            name: `${cartItem.subtitle} - ${cartItem.title}`,
            price: cartItem.unitPrice,
            quantity: cartItem.quantity,
            variant: cartItem.variantId,
          })
          ga.ecommerce.setAction('add')
          ga.ecommerce.send('event', 'UX', 'click', 'add to cart')
        } catch (err) {
          logger.error('Failed PRODUCT_ADDED', err)
        }
      }),
    )

    //track remove from cart
    subscribers.push(
      storeEventLister(StoreEvents.PRODUCT_REMOVED, m => {
        const cartItem = m.payload

        logger.print('PRODUCT_REMOVED', cartItem)

        try {
          ga.ecommerce.addProduct({
            id: cartItem.id,
            name: `${cartItem.subtitle} - ${cartItem.title}`,
            price: cartItem.unitPrice,
            quantity: cartItem.quantity,
            variant: cartItem.variantId,
          })
          ga.ecommerce.setAction('remove')
          ga.ecommerce.send('event', 'UX', 'click', 'remove from cart')
        } catch (err) {
          logger.error('Failed PRODUCT_REMOVED', err)
        }
      }),
    )

    //track start checkout
    subscribers.push(
      manualEventListener('checkout_clicked', m => {
        const cartItems = m

        logger.print('CHECKOUT_PAYMENT_STARTED', cartItems)

        try {
          cartItems.forEach(cartItem => {
            ga.ecommerce.addProduct({
              id: cartItem.id,
              name: `${cartItem.subtitle} - ${cartItem.title}`,
              price: cartItem.unitPrice,
              quantity: cartItem.quantity,
              variant: cartItem.variantId,
            })
          })

          ga.ecommerce.setAction('remove')
          ga.ecommerce.send('event', 'UX', 'click', 'remove from cart')
        } catch (err) {
          logger.error('Failed CHECKOUT_PAYMENT_STARTED', err)
        }
      }),
    )

    //track purchase
    subscribers.push(
      storeEventLister(StoreEvents.CHECKOUT_ORDER_CLOSED, m => {
        const order = m.payload

        logger.print('CHECKOUT_ORDER_CLOSED', order)

        try {
          order.orderItems.forEach(element => {
            ga.ecommerce.addProduct({
              id: order.id,
              name: element.title,
              price: element.unitPrice,
              quantity: element.quantity,
              variant: element.variantId,
            })
          })
          ga.ecommerce.setAction('purchase', {
            id: order.id,
          })
          ga.ecommerce.send('event', 'pageview')
        } catch (err) {
          logger.error('Failed ORDER_CLOSED', err)
        }
      }),
    )
  }
  return subscribers
}
